import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import PresentTextField from '../../../components/inputs/PresentTextField';


const styles = {
  card: {
    marginBottom: '1.5rem'
  },
  inputWrapper: {
    paddingX: '0.5rem'
  },
  contact: {
    py: '1rem'
  }
}

const ProfileCompany = () => {
  const [company, setCompany] = useState({
    _id: '',
    name: '',
    address: '',
    city: '',
    phoneNumber: '',
    email: '',
    taxType: '',
    nit: '',
    contactName: '',
    contactPhoneNumber: '',
    contactEmail: '',
  });

  const current = useSelector(state => state.companies.current);
  const statistics = useSelector(state => state.companies.statistics);
    
  useEffect(() => setCompany({ ...company, ...current }), [current]);

  return (
    <Card sx={styles.card}>
      <CardHeader title="Datos de la empresa" />
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Nombre" name="name" value={company.name} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Ciudad" name="city" value={company.city} />
          </Grid>
          <Grid item xs={12} md={12} sx={styles.inputWrapper}>
            <PresentTextField label="Dirección" name="address" value={company.address} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Correo electrónico" name="email" value={company.email} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Teléfono móvil" name="phoneNumber" value={company.phoneNumber} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="NIT" name="nit" value={company.nit} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Tipo de contribuyente" name="taxType" value={company.taxType} />
          </Grid>

          <Grid item xs={12} sx={styles.contact}>
            <Typography variant="h6">Contacto</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Nombre de contacto" name="contactName" value={company.contactName} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Correo de contacto" name="contactEmail" value={company.contactEmail} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Teléfono de contacto" name="contactPhoneNumber" value={company.contactPhoneNumber} />
          </Grid>

          <Grid item xs={12} sx={styles.contact}>
            <Typography variant="h6">Estadísticas</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Empleados totales" name="total" value={statistics.total ?? 0} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Empleados activos" name="current" value={statistics.current ?? 0} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Empleados pasados" name="past" value={statistics.past ?? 0} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ProfileCompany;
